(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["caselia-size-chart-filter"] && !Shopify.designMode) return;
  try {
    (() => {
  const source = document.querySelector('[data-caselia-size-filter]');
  if (!source) return;
  const normalize = (value) => {
    if (/^TALLA\s+[ÚU]NICA\b/i.test(String(value).trim())) return 'ONE_SIZE';
    const match = String(value).trim().toUpperCase().match(/^(XS|XXXL|XXL|[2-5]XL|XL|S|M|L)\b/);
    if (!match) return null;
    return match[1] === 'XXL' ? '2XL' : match[1] === 'XXXL' ? '3XL' : match[1];
  };
  const offered = new Set(Array.from(source.querySelectorAll('[data-caselia-size-value]'), (element) => normalize(element.dataset.caseliaSizeValue)).filter(Boolean));
  if (!offered.size) return;
  const filterCharts = () => {
    document.querySelectorAll('.ks-chart-individual').forEach((chart) => {
      const heading = chart.querySelector('.ks-table-header');
      if (!heading || heading.textContent.trim().replace(/\s+/g, ' ') !== 'GUÍA DE TALLAS · CASÉLIA') return;
      chart.querySelectorAll('table.ks-table tr').forEach((row) => {
        const size = normalize(row.cells[0]?.textContent || '');
        if (!size) return;
        const excluded = !offered.has(size);
        row.classList.toggle('caselia-size-row-hidden', excluded);
        if (excluded) {
          row.style.setProperty('display', 'none', 'important');
          row.setAttribute('aria-hidden', 'true');
        } else {
          row.style.removeProperty('display');
          row.removeAttribute('aria-hidden');
        }
      });
      if (offered.size === 1 && offered.has('ONE_SIZE') && source.dataset.caseliaOneSizeDetails) {
        const table = chart.querySelector('table.ks-table');
        if (table && table.dataset.caseliaOneSize !== 'true') {
          const rows = Array.from(table.rows);
          rows.forEach((row) => {
            if (normalize(row.cells[0]?.textContent || '') !== 'ONE_SIZE') {
              row.style.setProperty('display', 'none', 'important');
              row.setAttribute('aria-hidden', 'true');
              return;
            }
            row.cells[0].textContent = `${row.cells[0].textContent.trim()} · ${source.dataset.caseliaOneSizeDetails}`;
            row.cells[0].colSpan = 4;
            Array.from(row.cells).slice(1).forEach((cell) => cell.style.setProperty('display', 'none', 'important'));
          });
          table.dataset.caseliaOneSize = 'true';
          const footer = chart.querySelector('.ks-table-footer');
          if (footer) footer.style.setProperty('display', 'none', 'important');
        }
      }
    });
  };
  filterCharts();
  const observer = new MutationObserver((records) => {
    if (records.some((record) => record.addedNodes.length)) filterCharts();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', filterCharts);
})();
  } catch(e) { console.error(e); }
})();

})();
